module.exports = __webpack_public_path__ + "img/专利认证.654e6d94.svg";